// apps/client/src/components/WhatsNewModal.tsx

import { useEffect, useState } from "react";
import { useBodyScrollLock } from "../lib/use-body-scroll-lock";

function hasSeenVersion(): boolean {
  return localStorage.getItem("lastSeenVersion") === __APP_VERSION__;
}

function markVersionSeen() {
  localStorage.setItem("lastSeenVersion", __APP_VERSION__);
}

export function WhatsNewModal() {
  const [visible, setVisible] = useState(() => !hasSeenVersion() && __RELEASE_NOTES__.length > 0);

  useBodyScrollLock(visible);

  const handleClose = () => {
    markVersionSeen();
    setVisible(false);
  };

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === "Escape") handleClose();
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, []);

  if (!visible) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/60 z-50" onClick={handleClose} />
      <div className="fixed inset-0 flex items-end sm:items-center justify-center z-50 pointer-events-none">
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="whats-new-title"
          className="bg-white rounded-t-2xl sm:rounded-2xl p-6 shadow-2xl w-full sm:max-w-sm pointer-events-auto"
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center shrink-0">
              <svg
                className="w-5 h-5 text-blue-600"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                viewBox="0 0 24 24"
              >
                <path d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09Z" />
              </svg>
            </div>
            <div>
              <p className="text-xs text-gray-400 leading-none">v{__APP_VERSION__}</p>
              <h2 id="whats-new-title" className="text-base font-bold text-gray-900 leading-tight">
                Novità in questa versione
              </h2>
            </div>
          </div>
          <p className="text-sm text-gray-600 leading-relaxed mb-6 whitespace-pre-line max-h-[50vh] overflow-y-auto">
            {__RELEASE_NOTES__}
          </p>
          <button
            type="button"
            onClick={handleClose}
            className="w-full bg-blue-600 text-white text-sm font-semibold py-2.5 rounded-xl hover:bg-blue-700 transition-colors"
          >
            Ho capito
          </button>
        </div>
      </div>
    </>
  );
}
